import React from "react"
import _map from "lodash/map"
import styled from "styled-components"
import { useTagsQuery } from "@timenotes/shared/src/services/tags/tags.hooks"
import RecordsSelect from "../records-select"
import FilterInput from "./filter-input"
import { TApiTag } from "@timenotes/shared/src/services/api-client/types"
import { cloneDeep } from "lodash"

export interface TagsFilterProps {
  style?: React.CSSProperties
  width?: string
  values?: string[]
  disabled?: boolean
  children?: React.ReactChild
  noUpperInput?: boolean
  autoFocus?: boolean
  onChange?(values: string[], tags: TApiTag[]): void
  onBlur?(): void
  hide?(): void
  addNoTagOption?: boolean
}

const Wrapper = styled.div`
  .ant-popover {
    width: 250px;
  }
`

const TagsFilter = (props: TagsFilterProps): JSX.Element => {
  const {
    values,
    width,
    disabled,
    onChange,
    onBlur,
    children,
    autoFocus,
    noUpperInput,
    addNoTagOption,
    hide,
  } = props

  const tagsQuery = useTagsQuery({})
  let tags = tagsQuery.data?.data || []
  const isLoading = tagsQuery.isFetching

  // Include no tag fake option tag
  if (!!addNoTagOption) {
    tags = tagsWithNoTagOption(tags)
  }

  const allTags = tags

  const handleOnChange = !onChange
    ? undefined
    : (tags: TApiTag[]) => {
      onChange(
        tags.map((t) => t.id),
        tags
      )
    }

  const selectedTags = allTags.filter((tag) => {
    return values?.includes(tag.id)
  })

  const tagsOptions = _map(tags, (tag) => ({ value: tag }))

  const selectOptions = [
    {
      label: "Tags",
      allFilters: true,
      options: tagsOptions,
    },
  ]

  return (
    <>
      {!noUpperInput && (
        <FilterInput placeholder="Tag" count={values?.length}>
          <RecordsSelect<TApiTag>
            open={true}
            loading={isLoading}
            disabled={isLoading}
            style={{
              width: "300px",
              zIndex: "1000",
            }}
            valueProp="id"
            labelProp="name"
            searchProp="name"
            placeholder="Tag"
            showSearch={true}
            mode="multiple"
            options={selectOptions}
            onChange={handleOnChange as any}
            onBlur={onBlur}
            value={selectedTags as any}
            autoFocus={true}
            dropdownMatchSelectWidth={true}
            getPopupContainer={(node) => {
              return node
            }}
            filterInputMode={true}
          />
          <div className="options-wrapper"></div>
        </FilterInput>
      )}
      {noUpperInput && (
        <RecordsSelect<TApiTag>
          onKeyDown={(e) => {
            if (e.key === "Escape") {
              hide && hide()
            }
          }}
          open={true}
          loading={isLoading}
          disabled={isLoading}
          style={{
            width: "300px",
            zIndex: "1000",
          }}
          valueProp="id"
          labelProp="name"
          searchProp="name"
          placeholder="Tag"
          showSearch={true}
          mode="multiple"
          options={selectOptions}
          onChange={handleOnChange as any}
          onBlur={onBlur}
          value={selectedTags as any}
          autoFocus={autoFocus}
          dropdownMatchSelectWidth={true}
          getPopupContainer={(node) => {
            return node
          }}
          filterInputMode={true}
        />
      )}
    </>
  )
}

const tagsWithNoTagOption = (tags: TApiTag[]): TApiTag[] => {
  const tagsCopy = cloneDeep(tags)

  tagsCopy.unshift({
      id: 'no_tag',
      name: 'No tag',
      // TODO: setup color theme for empty tag
      color: '#eee',
      status: 'active',
  })

  return tagsCopy
}

export default TagsFilter
